import "./Standard.css"
import { useNavigate } from 'react-router-dom';

const Standard = ({data}) => {

    const mainModel = data.filter((item) => {
        return !item.premium;
      });

      const makeWish = async (id, title) => {
        try {
          await navigator.clipboard.writeText(
            `Olá gostaria de comprar as modificações do ${title} ${id}`
          );
          console.log("Content copied to clipboard");
          alert(
            "Foi copiado o nome e o código do template, entre em contato em nossas redes sociais e cole o texto copiado"
          );
          navigate("/redes");
        } catch (err) {
          console.error("Failed to copy: ", err);
        }
      };

      const navigate = useNavigate();
  return (
    <div className="standard_container">
        <div className="standard_title_container">
            <h2>Modelos Padrões</h2>
            <span>Modelos simples e funcionais</span>
        </div>
        <div className="all_content">
          {mainModel &&
            mainModel.map((item) => (
            <div key={item.id} className="item_container">
              <img src={item.img} alt={item.title}/>
              <p className="title_post">{item.title}</p>
              {item.premium && <span className="span_premium">Prêmio</span>}
              {!item.premium && <span className="span_main">Padrão</span>}
              <div className="buttons_container">
                    <button
                      className="btn_chat"
                      onClick={() => makeWish(item.id, item.title)}
                    >
                      Fazer Pedido
                    </button>
                    <button
                      className="btn_chat"
                      onClick={() => window.open(item.link)}
                    >
                      Ver ao vivo
                    </button>
                  </div>
              </div>
            ))}
          <div className="item_container background_gradient_main" onClick={() => navigate("/")}>
            <span>+</span>
            <p>Ver Todos +</p>
          </div>
        </div>
    </div>
  )
}

export default Standard